<template lang="pug">
  div.garbage.country-communities
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :endpointExport="getExportPoint"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      :actionColumnWidth="100"
    )

    router-view
</template>

<script>
import { garbage } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import { export_document } from '@/api/api-endpoints'
import { GARBAGE_TYPE_CODES } from '@/config/config'

export default {
  mixins: [tableMixin],
  methods: {
    getEndpoint(route) {
      return garbage.garbages(route, 'country_community')
    },
    getDeleteUrl(id) {
      return garbage.garbageDelete(id)
    },
    getExportPoint() {
      return export_document.garbage(
        GARBAGE_TYPE_CODES.COUNTRY_COMMUNITY,
        this.$route
      )
    },
  },
}
</script>
